var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTooltip = function SvgTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 13",
    fill: "#CACBD6",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm0 1a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.094 5.91c-.709-.71-1.379-.592-1.773-.296l-.59.59c.196 0 .742-.292 1.181 0 .887.592-.295 1.183-.59 2.66-.296 1.477 1.181 1.477 2.363.59-1.89.473-1.576-.393-1.182-.886.493-.59 1.3-1.95.591-2.659ZM8.275 4.432a.886.886 0 1 1-1.773 0 .886.886 0 0 1 1.773 0Z"
  })));
};

export default SvgTooltip;